import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHNivelDel = async (credentials, data) => {
    const body = {
        service: "RNHNivelDel",
        params: {
            rnhNivelId: data?.id || null,
            rnhNivelVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
